module.exports = __webpack_public_path__ + "static/media/cross.299e2ebf.svg";